<template dir="rtl">
  <div class="container mt-4" dir="rtl">
    <sidebar></sidebar>
    <!-- Jobs -->
    <div class="card-panel-main col-lg-9 mb-5" style="transform: translateX(-19vw)">
      <div class="row">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="d-flex justify-content-between">
              <h2 style="font-size: 1.2vw !important; text-align: right">ارزیابی نیاز ها و انتظارات به تفکیک ذی نفعان</h2>
              <button class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>
            </div>
            <hr class="mb-3">
            <main class="row flex-nowrap">
              <table class="table table-striped">
                <thead>
                <tr class="sticky-header">
                  <th style="width: 1vw;">ردیف</th>
                  <th>دسته</th>
                  <th>گروه</th>
                  <th>ذی نفع</th>
                  <th style="width: 7vw;">نیازها و انتظارات</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in all_items" :key="item.id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.parents_names.category }}</td>
                  <td>{{ item.parents_names.group }}</td>
                  <td>{{ item.title }}</td>
                  <td>
                    <button class="btn btn-primary btn-submit-1" @click="openModal(item.id)">ارزیابی</button>
                  </td>
                </tr>
                </tbody>
              </table>
            </main>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="Beneficiaries_modal" style="z-index: 9999; width: 80vw;">
    <div>
      <p>ارزیابی نیاز ها و انتظارات ذی نفع ....</p>
      <p @click="closeModal">❌</p>
    </div>
    <div>
      <div class="w-100 col-12">
        <div style="overflow-y:scroll; width: 100%; height: 30vw;">
          <table class="table table-striped w-100">
            <thead>
            <tr class="sticky-header">
              <th style="width: 1vw;">ردیف</th>
              <th>فرآیند</th>
              <th>عنوان نیاز</th>
              <th>نوع نیاز</th>
              <th>امتیاز</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in beneficiary_items" :key="item.id">
              <td>{{ index + 1 }}</td>
              <td>{{ item.processes_name }}</td>
              <td>{{ item.title }}</td>
              <td>{{ item.type_name }}</td>
              <td>
                <select v-model="item.score" class="form-select">
                  <option value="1">بی اهمیت</option>
                  <option value="2">کم اهمیت</option>
                  <option value="3">معمولی</option>
                  <option value="4">مهم</option>
                  <option value="5">بسیار مهم</option>
                </select>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <hr class="mt-2">
        <div class="d-flex align-items-center mt-2 mb-2 justify-content-center w-100 flex-row-reverse">
          <button @click="storeAllScores" class="btn btn-submit-1 btn-primary">ذخیره</button>
          <button @click="closeModal" class="btn btn-primary btn-back mx-2">بازگشت</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import Sidebar from "@/components/Sidebar/Sidebar.vue";

const toast = useToast();

export default {
  components: { Sidebar },
  data() {
    return {
      all_items: [],
      beneficiary_items: [],
      Beneficiaries_modal: false,
      id: null,
    };
  },
  methods: {
    openModal(id) {
      this.id = id;
      this.Beneficiaries_modal = true;
      this.fetchBeneficiaryItems(id);
    },
    closeModal() {
      this.Beneficiaries_modal = false;
    },
    fetchBeneficiaryItems(id) {
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${this.base_url}/StakeholderSurvey/${id}`, requestOptions)
          .then((response) => response.json())
          .then((response) => {
            if (response) {
              this.beneficiary_items = response;
            }
          })
          .catch((error) => console.error(error));
    },
    storeAllScores() {
      const myHeaders = new Headers();
      const formData = new FormData();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      formData.append(`items`, JSON.stringify(this.beneficiary_items));
      ;

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formData,
        redirect: "follow",
      };

      fetch(`${this.base_url}/stakeholder_survey_scores/store`, requestOptions)
          .then((response) => response.json())
          .then((response) => {
            if (response.error) {
              toast.error(response.error);
              return;
            }

            if (response.message) {
              toast.success(response.message);
              this.fetchBeneficiaryItems(this.id);
            }
          })
          .catch((error) => console.error(error));
    },
    all() {
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${this.base_url}/StakeholderSurvey`, requestOptions)
          .then((response) => response.json())
          .then((response) => {
            if (response.all) {
              this.all_items = response.all;
            }
          })
          .catch((error) => console.error(error));
    },
  },
  mounted() {
    this.all();
  },
};
</script>

<style lang="scss" scoped>

</style>
